import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import PinChangeForm from '../../components/pin/PinChangeForm';
import Storage from '../../services/Storage';

export default function ChangePin() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <PinChangeForm />
  );
}